import { Component } from '@angular/core'
import { AppDownloadComponent } from '@appShared/components/app-download/app-download.component'
import { EXTERNAL_URIS } from '@appShared/external.uris'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { environment } from '@appEnvironments/environment'

@Component({
    selector: 'app-capture',
    imports: [AppDownloadComponent],
    templateUrl: './capture.component.html',
})
export class CaptureComponent {
   supportUri = `/${SITE_DIRECTORY_ROUTES.support.uri}`

   private _captureClientApps = environment.clientApps.capture
   androidAppUri = this._captureClientApps.android.download
   androidAppDownloadInstructionsUri = EXTERNAL_URIS.android_app_dowload_instructions.uri
   iosAppUri = this._captureClientApps.iOS.download
   iOSAppDownloadInstructionsUri = EXTERNAL_URIS.ios_app_dowload_instructions.uri
}
